export default __webpack_public_path__ + "images/f016287ed4f7a380c99b6e7028b1b3ff-top.svg";